export default "__VITE_ASSET__CrpcO9TV__"